import axios from "axios";

import { API_TIMEOUT_IN_MS, IAxiosRequestWithRetryConfig } from "@tm/api-utils";

import { interceptors } from "@tm/api-utils";

const AXIOS_HTTPS_CONFIG: IAxiosRequestWithRetryConfig = {
  timeout: API_TIMEOUT_IN_MS,
  withCredentials: true,
  retry: 1,
};

export const API_HTTPS = axios.create(AXIOS_HTTPS_CONFIG);

API_HTTPS.interceptors.request.use(function (
  config: IAxiosRequestWithRetryConfig
) {
  const { cookie, ...headersWithoutCookie } =
    interceptors.enhanceRequestHeaders(config.headers);
  config.headers = headersWithoutCookie;
  return config;
});

API_HTTPS.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return interceptors.retryAxiosRequest(error, API_HTTPS);
  }
);
